import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';
import { getEmailReportingLeaderboard } from '../api/leaderboard';

export interface IDataEmailReportingList {
  rank: number;
  learner_id: number;
  learner_email?: string;
  first_name: string;
  last_name: string;
  segment?: string;
  total_points: number;
  training_status: number;
  report_count?: number;
  average_response_time_minutes?: string;

}

export interface IGroupEmailReportingList {
  rank: number;
  group: string;
  average_points: number;
  has_group: boolean;
}

export interface IPagination {
  "total_items": number,
  "total_page": number,
  "offset": number,
  "limit": number,
  "has_more": boolean
}

export interface IDataEmailReporting {
  rankings: {
    data:IDataEmailReportingList[],
    pagination:IPagination
  };
  groups: {
    data: IGroupEmailReportingList[],
    pagination:IPagination
  };
}

export interface GetAssignedLearningListObjectState {
  dataEmailReporting: IDataEmailReporting
  isLoading: boolean;
  error?: string;
}

const initialState: GetAssignedLearningListObjectState = {
  dataEmailReporting: {
    rankings: {
      data:[],
      pagination:{
        total_items: 0,
        total_page: 0,
        offset: 1,
        limit: 1,
        has_more: false
      }
    },
    groups: {
      data:[],
      pagination:{
        total_items: 0,
        total_page: 0,
        offset: 1,
        limit: 1,
        has_more: false
      }
    },
  },
  isLoading: false,
  error: undefined
};

export const getEmailReportingListEvents = createAsyncThunk(
  'getEmailReportingListEventLeaderboard',
  async (params: any) => {
    const response = await getEmailReportingLeaderboard(params);
    return response ? response : initialState;
  }
);
export const getEmailReportingListSlice = createSlice({
  name: 'getEmailReportingListEvents',
  initialState,
  reducers: {
      removeEmailReporting: (state) => {
        state.isLoading = false;
        state.dataEmailReporting = initialState.dataEmailReporting;
        state.error = undefined;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getEmailReportingListEvents.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(
      getEmailReportingListEvents.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.dataEmailReporting = action.payload;
        state.error = undefined;
      }
    );

    builder.addCase(getEmailReportingListEvents.rejected, (state, action) => {
      state.isLoading = false;
      state.dataEmailReporting = initialState.dataEmailReporting;
      state.error = action.payload as string;
    });
  }
});

export const { removeEmailReporting  } = getEmailReportingListSlice.actions;

export const getEmailReportingListEventsDataSelector = (state: RootState) =>
  state.getEmailReportingListEvents;
export default getEmailReportingListSlice.reducer;
